module.exports = __webpack_public_path__ + "media/פתוח.fb2d3632.mp3";